import { useRouter } from 'next/router';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import SiteView from 'components/Site/View';
import SignupForm from 'components/Forms/Signup';
import SignInForm from 'components/Forms/SignIn';
import cns from 'classnames';
import styles from './access-view.module.scss';
import Image from 'next/image';
import { useProductEvents } from 'hooks';

const AccessView = ({ title }) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { pathname, query } = router;
  const { tab = 'auth', then } = query;
  const events = useProductEvents();

  return (
    <SiteView>
      <div className={styles.root}>

        <div className={styles.tab_nav}>
          <Link href={{ pathname, query: { ...query, tab: 'auth' } }} replace>
            <a
              className={cns(styles.nav_item, {
                active: tab === 'auth'
              })}
            >
              {t('auth.enter')}
            </a>
          </Link>

          <Link href={{ pathname, query: { tab: 'signup' } }} replace>
            <a
              className={cns(styles.nav_item, {
                active: tab === 'signup'
              })}
            >
              {t('auth.registration')}
            </a>
          </Link>
        </div>
        <div className={styles.tab_content}>
          <If condition={tab === 'auth'}>
            <SignInForm
              thenURL={then}
            />
          </If>
          <If condition={tab === 'signup'}>
            <SignupForm />
          </If>
        </div>

      </div>
    </SiteView>
  )
}

export default AccessView;